/**
 * Removes a highlightNode from the DOM, optionally waiting for any host callbacks
 * to finish before actually removing the node.
 */
export async function removeHighlightNode(
  node?: HTMLSpanElement,
  onHide?: (node: HTMLSpanElement) => Promise<void>
): Promise<void> {
  if (!node) {
    return;
  }

  // Allow the host to finish its onHide callback, running exit transitions and
  // similar before fully removing the node.
  await onHide?.(node);

  // In order to preserve event listeners we create a range containing the
  // highlightnode to remove and simply insert its content (i.e. NOT creating
  // new nodes, hence preserving listeners etc.) directly into the
  // dom next to the highlightnode we will remove afterwards.
  const extractorRange = document.createRange();
  extractorRange.selectNodeContents(node);
  node.parentNode?.insertBefore(extractorRange.extractContents(), node);
  node.parentElement?.removeChild(node);
}
